import { ReactNode } from "react"
import { L4PrintBound } from "./L4Print"
import { L2ErfRow } from "../l2/L2ErfRow"

interface L4ErfRowProps {
	xpath: string
	printBound?: boolean
	children: ReactNode
}

const L4ErfRow = ({xpath, printBound, children}: L4ErfRowProps) => {
	const content = (
		<L2ErfRow>
			{children}
		</L2ErfRow>
	)
	if(printBound === false) {
		return content
	}
	return (
		<L4PrintBound xpath={xpath}>
			{content}
		</L4PrintBound>
	)
}

export default L4ErfRow
